var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedinfooter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.76953 11.8594H0.408203V4.26758H2.76953V11.8594ZM1.57617 3.25195C0.839844 3.25195 0.230469 2.61719 0.230469 1.85547C0.230469 1.11914 0.839844 0.509766 1.57617 0.509766C2.33789 0.509766 2.94727 1.11914 2.94727 1.85547C2.94727 2.61719 2.33789 3.25195 1.57617 3.25195ZM11.5801 11.8594H9.24414V8.17773C9.24414 7.28906 9.21875 6.17188 8 6.17188C6.78125 6.17188 6.60352 7.11133 6.60352 8.10156V11.8594H4.24219V4.26758H6.50195V5.30859H6.52734C6.85742 4.72461 7.61914 4.08984 8.76172 4.08984C11.1484 4.08984 11.6055 5.66406 11.6055 7.69531V11.8594H11.5801Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinfooter);
export default __webpack_public_path__ + "static/media/linkedinfooter.4abd1231989193e3859f894bd20ebd15.svg";
export { ForwardRef as ReactComponent };